import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { makeGetRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function Chart1({ classificationSelected, chartUpdate }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [responseData, setResponseData] = useState({})
  const [labels, setLabels] = useState([])
  const [dataSet, setDataSet] = useState([])

  useEffect(() => {
    fetchData(classificationSelected)
  }, [classificationSelected])
  useEffect(() => {
    fetchData(classificationSelected)
  }, [chartUpdate])

  const fetchData = async () => {
    const response = await makeGetRequest(
      '/api/Finance/sous-cat-chart1/?classification=' + classificationSelected,
      {},
      true,
    )
    if (response.status === 200) {
      setLabels(response.data.labels)
      setDataSet(response.data.data)
      setResponseData(response.data)
    }
  }
  const options = {
    aspectRatio: 1,
    maintainAspectRatio: false,
    responsive: true,
    clip: true,
    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [value] + ' %'
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',

        display: false,
      },

      legend: {
        display: true,
        position: 'right',
        align: 'center',
      },
      title: {
        display: false,
        text: '',
      },
    },
  }
  const data = {
    labels,
    datasets: [
      {
        label: '',
        data: dataSet,
        backgroundColor: ['#0d6efd', '#fd7e14', '#0dcaf0', '#6c757d', '#dc3545', '#fd7e14'],
        borderColor: ['#0d6efd', '#fd7e14', '#0dcaf0', '#6c757d', '#dc3545', '#fd7e14'],
        borderWidth: 0,
        hoverOffset: 8,
        precision: 5,
      },
    ],
  }

  return (
    <Box display={'flex'} width={'100%'} flexDirection={'column'}>
      <Box height={350} position={'relative'} width={'100%'}>
        <Doughnut data={data} options={options} />
      </Box>
      <Box display={'flex'} width={'100%'} justifyContent={'space-around'} mt={8}>
        <Box textAlign={'center'}>
          <Box color={'white'}>{responseData.revenu} €</Box>
          <Box color={'gray'}>{t('finance.monBudget.referenceIncomeLabel')}</Box>
        </Box>
        <Box textAlign={'center'}>
          <Box color={'white'}>{(responseData.revenu * responseData.repartir) / 100} €</Box>
          <Box color={'gray'}>{t('finance.monBudget.amountToDistribute')}</Box>
        </Box>
        <Box textAlign={'center'}>
          <Box color={'white'}>{responseData.repartir} %</Box>
          <Box color={'gray'}>{t('finance.monBudget.toDistributePct')}</Box>
        </Box>
      </Box>
    </Box>
  )
}
